import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from '../reducers';
import { createDeferredLogRocketReduxMiddleware, isLogRocketConfigured } from '../observability/logrocket';

const middlewares = [thunkMiddleware];
const shouldUseLogRocketRedux = isLogRocketConfigured();

if (process.env.NODE_ENV === 'development') {
    middlewares.push(createLogger());
}

if (shouldUseLogRocketRedux) {
    middlewares.push(createDeferredLogRocketReduxMiddleware());
}

export const store = createStore(
    rootReducer,
    applyMiddleware(...middlewares)
);
